var exports = {
  "zr": "x93eb46d8--bfc6c8--root",
  "Nr": "x93eb46d8--bfc6c8--card",
  "jW": "x93eb46d8--bfc6c8--photo",
  "Qs": "x93eb46d8--bfc6c8--content",
  "VG": "x93eb46d8--bfc6c8--title-block",
};

module.exports = exports;
